import React, { Component } from 'react'
import PatientSidebar from '../components/PatientSidebar'
import Today from '../pages/Today'
import History from '../pages/History'
import Personal from '../pages/Personal'
import Notes from '../pages/Notes'
import Treatments from '../pages/Treatments'
import VitalSigns from '../pages/VitalSigns'
import { withStyles } from '@material-ui/core/styles'
import { getPatient } from '../api'
import humps from 'humps'

const styles = {
  page: {
    height: '100%',
    display: 'flex'
  },
  subpage: {
    width: '100%'
  }
}

const pages = {
  today: Today,
  history: History,
  personal: Personal,
  treatments: Treatments,
  notes: Notes,
  vitalSigns: VitalSigns,
}

class Patient extends Component {
  constructor (props) {
    super(props)

    this.id = this.props.match.params.id
    this.state = {}
  }


  componentDidMount () {
    // API CALL FOR PATIENT INFO FOR PATIENT WITH MATCHED ID
    this.fetchPatient()
  }

  fetchPatient () {
    getPatient(this.id).then(patient => this.setState({patient: patient}))
  }

  switchTabs = (tab) => { this.props.history.push(`/patients/${this.id}/${tab}`) }
  activeTab = () => this.props.match.params.dataSection || 'today'

  render () {
    const { classes } = this.props
    const { patient } = this.state
    const Subpage = pages[humps.camelize(this.activeTab())] || Today
    if (!patient) return <div/>
    return (
      <div className={classes.page}>
        <PatientSidebar
          patient={patient}
          selectedTab={this.activeTab()}
          switchTabs={tab => this.switchTabs(tab)}
          history={this.props.history}
        />
        <div className={classes.subpage}>
          <Subpage patient={patient} updatePatient={patient => this.setState({patient})}/>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Patient)



// WEBPACK FOOTER //
// ./src/pages/Patient.js